import React, { Component } from "react";
import Link from "react-router-dom/Link";
import "./WorkItem.css";
import Typography from "@material-ui/core/Typography";

class WorkItem extends Component {
  render() {
    const {
      work: { title, text, image },
    } = this.props;

    return (
      <Link to={`/work/${title}`}>
        <div className="itemContainer">
          <div className="itemContent">
            <img src={image} alt="" />
            <div className="itemContentText">
              <Typography variant="h3">{title}</Typography>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}

export default WorkItem;
